{
  "accounts": {
    "actions": "Aktionen",
    "addToGroup": "In Gruppe aufnehmen …",
    "empty": "Keine Konten.",
    "filter": "Konto suchen",
    "filters": {
      "all": "Alle {{n}}",
      "approval": "Wartet auf Freigabe {{n}}",
      "disabled": "Deaktiviert {{n}}",
      "invited": "Eingeladen {{n}}"
    },
    "historyOnly": "Nur Historie",
    "putIn": "{{name}} in eine Gruppe aufnehmen",
    "shown": "Anzeigen",
    "state": "Status",
    "states": {
      "active": "Aktiv",
      "disabled": "Deaktiviert",
      "pending_approval": "Ausstehende Freigabe",
      "pending_verification": "E-Mail nicht bestätigt",
      "rejected": "Abgelehnt"
    },
    "takeOut": "Aus {{group}} herausnehmen"
  },
  "deletedProjects": {
    "deleted": "Gelöscht am {{time}} von {{name}}",
    "hint": "Projekte, die jemand gelöscht hat. Wiederherstellen holt ein Projekt so zurück, wie es war. Nach seiner Wiederherstellungsfrist kann es endgültig gelöscht werden; seine Daten sind dann unwiderruflich entfernt.",
    "none": "Es wurde noch kein Projekt gelöscht.",
    "purge": "Endgültig löschen",
    "purgeMessage": "Alles, was das Projekt enthält, wird gelöscht und lässt sich nicht zurückholen. Nur sein Name und wer es gelöscht hat, bleiben in dieser Liste.",
    "purgeNotBuilt": "Das Löschen der Durchläufe, Inhalte und Wissensdaten eines Projekts ist noch nicht gebaut. Das Projekt bleibt wiederherstellbar.",
    "purgeNotYet": "Es kann noch wiederhergestellt werden. Endgültig löschen lässt es sich ab {{time}}.",
    "purgeTitle": "{{project}} endgültig löschen?",
    "purgeableFrom": "Kann ab {{time}} endgültig gelöscht werden",
    "purged": "Endgültig gelöscht am {{time}} von {{name}}",
    "restore": "Wiederherstellen",
    "states": {
      "deleted": "Wiederherstellbar",
      "purged": "Endgültig gelöscht",
      "purging": "Endgültiges Löschen nicht abgeschlossen"
    },
    "title": "Gelöschte Projekte"
  },
  "groups": {"title": "Gruppen"},
  "installation": {
    "accessRequests": "Personen können fehlende Berechtigungen anfragen",
    "accessRequestsHint": "Wo eine Berechtigung fehlt, fragen Personen sie an, und wer sie hinzufügen könnte, entscheidet. Aus: Sie erfahren trotzdem, wer entscheidet.",
    "changed": "Geändert: {{names}}",
    "creatorCurates": "Wer ein Projekt anlegt, kuratiert jede Art von Element",
    "deletedProjectRestoreDays": "Tage, die ein gelöschtes Projekt wiederherstellbar bleibt",
    "deletedProjectRestoreDaysHint": "Erst danach lässt sich ein gelöschtes Projekt endgültig löschen. Eine Änderung gilt für später gelöschte Projekte.",
    "firstStart": "Beim ersten Start aus der Konfigurationsdatei übernommen",
    "hint": "Grenzen, die Gruppen für neue Konten und die Regeln, mit denen neue Projekte beginnen. Jede Änderung braucht eine Begründung.",
    "history": "Änderungen",
    "memberProjectLimit": "Projekte, die ein Mitglied anlegen darf",
    "memberProjectLimitHint": "Leer: unbegrenzt. Für Administratorinnen und Administratoren gilt keine Grenze.",
    "names": {
      "access_requests": "Zugriff anfragen",
      "creator_curates": "Ersteller kuratiert",
      "deleted_project_restore_days": "Wiederherstellungsfrist gelöschter Projekte",
      "member_project_limit": "Projektgrenze",
      "members_create_projects": "Mitglieder legen Projekte an",
      "new_account_groups": "Gruppen für neue Konten",
      "new_projects": "Regeln für neue Projekte",
      "reasoning_levels": "Denkaufwand je Agent",
      "server_key_groups": "Gruppen für die Schlüssel des Servers"
    },
    "newAccountGroups": "Gruppen, in die neue Konten kommen",
    "newAccountGroupsHint": "Ab jetzt kommt jedes Konto, das aktiv wird, in diese Gruppen.",
    "newProjects": "Neue Projekte beginnen mit",
    "newProjectsHint": "Jedes Projekt kann seine Regeln danach selbst ändern. Eine Änderung hier lässt bestehende Projekte, wie sie sind.",
    "noGroups": "Noch keine Gruppen der Installation. Legen Sie zuerst unter Gruppen eine an.",
    "none": "Die Installation hat noch keine Einstellungen.",
    "reasoningLevels": "Denkaufwand je Agent",
    "reasoningLevelsHint": "Für Durchläufe und Personen, die ihn auf Standard lassen, wo der Agent ihn anbietet.",
    "title": "Einstellungen der Installation"
  },
  "invitations": {
    "by": "Eingeladen von {{name}}",
    "into": "zu {{project}}",
    "invited": "Eingeladen",
    "joins": "kommt in {{groups}}",
    "revoke": "Zurückziehen",
    "until": "bis {{time}}"
  },
  "onlyAdministrators": "Nur Administratorinnen und Administratoren verwalten die Installation.",
  "pages": {
    "accounts": "Konten",
    "deletedProjects": "Gelöschte Projekte",
    "groups": "Gruppen",
    "installation": "Installation",
    "researchSpace": "ResearchSpace",
    "serverKeys": "Server-Schlüssel"
  },
  "title": "Administration"
}
